export default [{
    title: "Costos",
    fontIcon: "money-bill-trend-up",
    resource: "Costos",
    action: "ver-costos",
    children: [{
            title: "Dashboard",
            icon: "LayoutIcon",
            resource: "Costos",
            action: "ver-costos-dashboard",
        }, {
            title: "Configuracion",
            icon: "SettingsIcon",
            resource: "Costos",
            action: "ver-costos-configuracion",
        }, {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Costos",
            action: "ver-costos-mantenimiento",
            children: [{
                route: "costos-personal-jerarquia",
                title: "Listado de personal por jerarquía",
                fontIcon: "clipboard-list",
                resource: "Costos",
                action: "ver-costos-personal-jerarquia",
            }, ]
        }, {
            title: "Transacciones",
            fontIcon: "exchange-alt",
            resource: "Costos",
            action: "ver-costos-transacciones"
        },
        {
            title: "Informes",
            resource: "Costos",
            fontIcon: "file-prescription",
            action: "ver-costos-informes",
        },
    ]
}]